import {
  Award,
  LineChart,
  Target,
  Palette,
  Workflow,
  Bot,
  FileBarChart,
  UserCheck,
  Zap,
  Headphones,
  TrendingUp,
  ShieldCheck,
} from "lucide-react";
import useReveal from "@/hooks/useReveal";

const TILES = [
  { icon: Award, title: "Proven Track Record" },
  { icon: LineChart, title: "Data-Driven Strategies" },
  { icon: Target, title: "ROI-Focused Execution" },
  { icon: Palette, title: "Creative That Converts" },
  { icon: Workflow, title: "End-to-End Growth Systems" },
  { icon: Bot, title: "AI-Powered Automation" },
  { icon: FileBarChart, title: "Transparent Weekly Reporting" },
  { icon: UserCheck, title: "Dedicated Account Manager" },
  { icon: Zap, title: "Fast Turnaround" },
  { icon: Headphones, title: "24x7 Support" },
  { icon: TrendingUp, title: "60+ Brands Scaled" },
  { icon: ShieldCheck, title: "No Long-Term Lock-ins" },
];

export default function WhyUs() {
  const ref = useReveal();
  return (
    <section
      id="why-us"
      ref={ref}
      data-testid="why-us-section"
      className="py-16 sm:py-24 bg-white"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center max-w-3xl mx-auto mb-14 fade-up">
          <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight text-[#B01116]">
            Why Choose Gold Mind Business?
          </h2>
          <p className="mt-5 text-base text-gray-600 leading-relaxed">
            Other agencies talk creative awards. We talk pipeline, cost per
            acquisition and payback period. If it doesn&apos;t move revenue, we
            don&apos;t ship it.
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
          {TILES.map((t, i) => (
            <div
              key={t.title}
              data-testid={`why-us-item-${i}`}
              className="bg-white p-6 rounded-xl border border-gray-100 shadow-sm hover:shadow-md hover:border-[#B01116]/30 transition-all flex flex-col items-center text-center gap-3 fade-up"
              style={{ transitionDelay: `${(i % 4) * 60}ms` }}
            >
              <div className="w-12 h-12 flex items-center justify-center text-[#B01116] bg-[#FDE8E8] rounded-full">
                <t.icon className="h-5 w-5" strokeWidth={2} />
              </div>
              <h3 className="font-accent text-sm sm:text-base font-bold text-gray-900 leading-snug">
                {t.title}
              </h3>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
